import * as React from 'react';

import { Person, User } from '../../../common/models';

interface UserMenuItemProps {
  user: User;
}

export const UserMenuItem = ({ user }: UserMenuItemProps) => {
  if (!user) {
    return null;
  }

  const person = user as Person;
  const altName = person.firstNamePreferred && person.firstNamePreferred !== person.firstName ? person.firstName : '';

  return (
    <a href="#" className="UserMenuItem">
      <div>
        {(user.code || person.studentId) ?
          ( <span className="text-muted pull-right">{user.code || person.studentId}</span> ) : ''
        }
        {user.name} {altName && '( ' + altName + ' )'}
      </div>
      {person.primaryTitle ? (
        <div className="text-muted">
          {person.primaryTitle}
          {person.homeDepartmentName ? ( <span> in {person.homeDepartmentName}</span> ) : ''}
        </div>
      ) : ''}
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/UserMenuItem.tsx